import script from "./BrowserInfoList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrowserInfoList.vue?vue&type=script&setup=true&lang=ts"

import "./BrowserInfoList.vue?vue&type=style&index=0&id=1bad18e4&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bad18e4"]])

export default __exports__